
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-a-installer",
      function () {
        return require("private-next-pages/add-a-installer.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add-a-installer"])
      });
    }
  